
<div class="search-container">
  <div class="search-bar" >
    @if (filters.get('query').value) {
      <button mat-icon-button (click)="clearSearch()"> <mat-icon>arrow_back</mat-icon> </button>
    }
    @else {
      <mat-icon class="icon-container">search</mat-icon>
    }
    <input [formControl]="filters.controls.query" name="search_query" autocomplete="off" autocorrect="off" spellcheck="false">
  </div>
  <button
    mat-icon-button
    class="primary"
    (click)="showFilters.set(!showFilters())"
    [matTooltip]="showFilters() ? 'Ocultar Filtros' : 'Mostrar Filtros'"
  >
    <mat-icon style="color: var(--mat-sys-on-primary);">filter_list</mat-icon>
  </button>
</div>

@if (showFilters()) {
  <div class="filter-container">
    <form [formGroup]="filters" class="filters form-row">
      <mat-form-field appearance="outline">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="'all'">Todos</mat-option>
          <mat-option *ngFor="let type of types" [value]="type">{{ titleForType(type) }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline"  (click)="picker.open()" class="custom-infix">
        <mat-label>Fecha de creacion</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Desde" formControlName="created_at_start">
          <input matEndDate placeholder="Hasta" formControlName="created_at_end">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      @if (providers()) {
        <mat-form-field appearance="outline">
          <mat-label>Por Proveedor</mat-label>
          <mat-select formControlName="owner_id[]" [multiple]="true">
            <mat-option class="mat-option" [value]="-1" selectAll>Seleccionar Todos</mat-option>
            <mat-option *ngFor="let provider of providers()" [value]="provider.id">
              {{ provider.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field appearance="outline">
        <mat-label>Respondida</mat-label>
        <mat-select formControlName="answered">
          <mat-option [value]="null"></mat-option>
          <mat-option value="true">Sí</mat-option>
          <mat-option value="false">No</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Bodega</mat-label>
        <mat-select formControlName="warehouse_ids[]" [multiple]="true">
          @for(warehouse of warehouses; track warehouse.id){
            <mat-option [value]="warehouse.id">{{warehouse.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (filters.get('type').value) {
        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="status_id[]" [multiple]="true">
            <mat-option [value]="'all'" selectAll>Seleccionar Todos</mat-option>
            <mat-option *ngFor="let status of statuses()" [value]="status.id">
              {{ status.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      }
    </form>
  </div>
}


<!-- DESKTOP VERSION -->

<div class="table-container display-desktop" appPagination>
  <div class="buttons">
    <button mat-mini-fab
      matTooltip="Cotizar"
      class="success"
      matTooltipPosition="above"
      go-to-create
      elementType="InventoryAction::Pricing"
      [enableDocumentSelection]="true"
      (afterClosed)="reload()"
      title="{{ 'InventoryAction::Pricing' | human }}"
      matTooltip="Cotizar"
    >
      <mat-icon>request_quote</mat-icon>
    </button>
    <button
      mat-mini-fab
      class="primary"
      matTooltipPosition="above"
      go-to-create
      elementType="InventoryAction::BuyOrder"
      [enableDocumentSelection]="true"
      (afterClosed)="reload()"
      title="{{ 'InventoryAction::BuyOrder' | human }}"
      matTooltip="Crear Orden de Compra"
    >
      <mat-icon>library_add</mat-icon>
    </button>
  </div>
  <mat-card class="box-shadowless">
    <mat-card-content style="padding: 0;">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows (matSortChange)="onSortChange($event)">

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Tipo </th>
          <td  mat-cell *matCellDef="let element">
            <mat-icon 
              class="icon-type"
              [class]="element.type | kebab: 'css'" 
              [matTooltip]="element.type | human">
              {{ iconForType(element.type) }}
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="correlative_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº </th>
          <td  mat-cell *matCellDef="let element"> {{ element.correlative_id }}</td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha creación </th>
          <td  mat-cell *matCellDef="let element"> {{ element.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="estimated_completion_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Estimada </th>
          <td  mat-cell *matCellDef="let element"> {{ element.estimated_completion_date | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef> Responsable </th>
          <td  mat-cell
               *matCellDef="let element"
               [matTooltip]="element.owner?.tooltip"
          >
            {{ element.owner?.name | titlecase }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total_quantity">
          <th mat-header-cell *matHeaderCellDef> Productos </th>
          <td  mat-cell *matCellDef="let element">  {{ element.inventory_action_products_count }} </td>
        </ng-container>

        <ng-container matColumnDef="answered">
          <th mat-header-cell *matHeaderCellDef> Respondida </th>
          <td  mat-cell *matCellDef="let element">  {{ element.draft ? 'No': 'Si' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Estado </th>
          <td  mat-cell *matCellDef="let element">
            <app-chip [color]="element.status.color" [text]="element.status.name"></app-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="warehouse_name">
          <th mat-header-cell *matHeaderCellDef> Bodega </th>
          <td  mat-cell *matCellDef="let element" > {{ (element.warehouse?.name | titlecase)|| '-' }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Acciones </th>
          <td mat-cell *matCellDef="let element">
            <div class="action-buttons">
              @if (canEdit(element) | async) {
                <button class="action-button"
                        mat-icon-button
                        (click)="stopPropagation($event)"
                        matTooltip="Editar {{element.type | human}}"
                        go-to-edit
                        [id]="element.id"
                        [type]="element.type"
                        (afterClosed)="reload()"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              }
            </div>
          </td>
        </ng-container>

        <tr mat-header-row  *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: displayedColumns;"
          go-to-details
          [element]="element"
          (afterClosed)="reload()"
        ></tr>
      </table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading()"></mat-progress-bar>

      <mat-progress-bar mode="indeterminate" *ngIf="isLoading()"></mat-progress-bar>
      
      <ng-template *ngIf=" !isLoading() && totalData === 0">
        <div class="empty">
          <span>No se han encontrado datos</span>
        </div>
      </ng-template>
      
      <div class="loading" *ngIf="isLoading()">
        <mat-spinner></mat-spinner>
      </div>

      <mat-paginator
        #paginator
        [length]="totalData"
        [pageSizeOptions]="pageSizes"
        showFirstLastButtons
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>

  
<!-- MOBILE VERSION -->

<div class="table-container display-mobile scroll-shadows" id="documents" appPagination (loadMore)="getMore()" [isLoading]="loadingMore" [page]="page" [totalPages]="totalPages">
  @for (document of dataSource.data; track document.id) {
    <div class="card" go-to-details [element]="document">
      <div class="card-content">
        <div class="card-details">
          <div class="row no-margin">
            <span class="small light">#{{document.correlative_id}}</span>
          </div>
          <div class="row title">
            <span class="bold">{{document.type | human}}</span>
            <span class="light">{{document.total | money}}
              </span>
          </div>
          <div class="row">
            <span>{{document.owner?.name}}</span>
          </div>
          <div class="row">
  
            <span> <i class="fas fa-check-circle" [style.color]="document.status?.id | status:'color'"></i>&nbsp;{{document.status?.name}}</span>
          </div>
        </div>
      </div>
    </div>
  }


  @if (dataSource.data && dataSource.data.length == 0 && !loadingMore) {
    <div class="empty">
      <span>No se han encontrado items</span>
    </div>
  }

  <div class="load-more" [hidden]="page >= totalPages" id="load-more">
    <mat-spinner [diameter]="20"></mat-spinner> Cargando items...
  </div>

  <div class="loading" [hidden]="!loadingMore">
    <mat-spinner></mat-spinner>
  </div>
</div>
